import { PropagateLoader } from "react-spinners";

export default function PageLoader() {
  return (
    <div
      style={{
        margin: "0 auto",
        textAlign: "center",
        padding: "20px 0px 40px",
      }}
    >
      <PropagateLoader color="#0B7C86" height={18} />
    </div>
  );
}
